const countFilterValues = (filter: Record<string, any>, excludeKeys: string[] = []) => {
    let hasDateRange = false;

  return Object.entries(filter).filter(([key, value]) => {
    if (excludeKeys.includes(key)) return false;
    if (value === null || value === undefined) return false;
    if (Array.isArray(value) && value.length === 0) return false;

    if (key === 'startDate' || key === 'endDate') {
      if (hasDateRange) return false; 
      hasDateRange = true;
      return filter.startDate || filter.endDate; 
    }

    return true;
  }).length;
}

export const FilterHelper = {
	countFilterValues
};